// redux/slices/filesSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IFileInfo } from '../../../../../../interface/interfaces';

interface IInitialState {
    files: IFileInfo[];
    lastUploadedFile: IFileInfo | null;
}

const initialState: IInitialState = {
    files: [],
    lastUploadedFile: null,
};

const fileListSlice = createSlice({
    name: 'fileListSlice',
    initialState,
    reducers: {
        setFiles: (state, action: PayloadAction<IFileInfo[]>) => {
            state.files = action.payload;
        },
        addFile: (state, action: PayloadAction<IFileInfo>) => {
            state.files.push(action.payload);
        },
        updateFileStatus: (state, action: PayloadAction<{ fileName: string; status: string }>) => {
            const file = state.files.find((file: IFileInfo) => file.name === action.payload.fileName);
            if (file) {
                file.status = action.payload.status;
            }
        },
        setLastUploadedFile: (state, action: PayloadAction<IFileInfo>) => {
            state.lastUploadedFile = action.payload;
        },
        removeFile: (state, action: PayloadAction<string>) => {
            state.files = state.files.filter((item: IFileInfo) => {
                return item.name !== action.payload;
            });
        },
        clearFiles: (state) => {
            state.files = [];
            state.lastUploadedFile = null;
        },
    },
});

export const { setFiles, addFile, updateFileStatus, setLastUploadedFile, clearFiles, removeFile } = fileListSlice.actions;
export default fileListSlice.reducer;
